module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul class="register-form__plans-container">\n	';
 subscriptionPlans.forEach(function(plan) { 
__p+='\n		<li class="register-form__plan">\n			<input id="'+
((__t=( plan.id ))==null?'':__t)+
'-'+
((__t=( formType ))==null?'':__t)+
'" type="radio" name="plan-id" value="'+
((__t=( plan.id ))==null?'':__t)+
'" ';
 if (plan.disabled) { 
__p+='disabled';
 } else if (plan.default) { 
__p+='checked';
 } 
__p+='>\n\n			<label for="'+
((__t=( plan.id ))==null?'':__t)+
'-'+
((__t=( formType ))==null?'':__t)+
'">\n				';
 if (plan.value) { 
__p+='\n					<p class="f-uppercase f-medium f-letter-spacing register-form__best-value">'+
((__t=( plan.value ))==null?'':__t)+
'</p>\n				';
 } 
__p+='\n\n				';
 if (isPayrollVariation) { 
__p+='\n					<span class="register-form__pricing-container">\n						<span class="register-form__plan-title f-medium" data-price="'+
((__t=( plan.priceValue ))==null?'':__t)+
'">'+
((__t=( plan.priceVariant ))==null?'':__t)+
'</span>\n					</span>\n				';
 } else { 
__p+='\n					<span class="register-form__pricing-container">\n						<span class="register-form__plan-title f-medium" data-price="'+
((__t=( plan.priceValue ))==null?'':__t)+
'">'+
((__t=( plan.price ))==null?'':__t)+
'</span>\n						';
 if (plan.monthlyPricing) { 
__p+='\n							<span class="register-form__monthly-pricing">'+
((__t=( plan.monthlyPricing ))==null?'':__t)+
'</span>\n						';
 } 
__p+='\n					</span>\n				';
 } 
__p+='\n\n				';
 if (plan.type === 'annually') { 
__p+='\n					<strong class="register-form__plan-detail">FREE GIFT! A practice guidebook ($25 value) with an annual membership</strong>\n				';
 } 
__p+='\n\n				';
 if (referral) { 
__p+='\n					<span class="register-form__plan-detail">'+
((__t=( plan.referralCopy ))==null?'':__t)+
'</span>\n				';
 } else { 
__p+='\n					<span class="register-form__plan-detail">'+
((__t=( plan.copy ))==null?'':__t)+
'</span>\n				';
 } 
__p+='\n			</label>\n		</li>\n	';
 }) 
__p+='\n</ul>\n';
}
return __p;
};
